export const convertToMb = (size: number) => {
    return `${size / 1024 / 1024}MB`;
};
